(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Load Lightbox2 from CDN only once
  function loadCss(href) {
    if (document.querySelector('link[data-about-lightbox2="1"][href="' + href + '"]')) return;
    var link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.setAttribute("data-about-lightbox2", "1");
    document.head.appendChild(link);
  }

  function loadJs(src, cb) {
    if (document.querySelector('script[data-about-lightbox2="1"][src="' + src + '"]')) {
      if (cb) cb();
      return;
    }
    var s = document.createElement("script");
    s.src = src;
    s.defer = true;
    s.setAttribute("data-about-lightbox2", "1");
    s.onload = function () { if (cb) cb(); };
    document.head.appendChild(s);
  }

  // Lightbox2 depends on jQuery for older builds; the current "lightbox2" CDN build
  // commonly used still expects it. We'll load jQuery too (only if needed).
  // If your theme already has jQuery, this won't duplicate.
  function ensureJquery(next) {
    if (window.jQuery) return next();
    loadJs("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js", next);
  }

  // Lightbox2 CDN
  loadCss("https://cdnjs.cloudflare.com/ajax/libs/lightbox2/2.11.4/css/lightbox.min.css");

  ensureJquery(function () {
    loadJs("https://cdnjs.cloudflare.com/ajax/libs/lightbox2/2.11.4/js/lightbox.min.js", function () {
      if (window.lightbox && typeof window.lightbox.option === "function") {
        window.lightbox.option({
          resizeDuration: 200,
          fadeDuration: 200,
          imageFadeDuration: 200,
          wrapAround: true,
          albumLabel: "Image %1 of %2",
          disableScrolling: true
        });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b"] && !Shopify.designMode) return;
  try {
    
// Function to initialize contact form
function initContactForm(sectionId) {
  const root = document.getElementById(`ContactFormSection-${sectionId}`);
  if (!root) return;
  
  const form = root.querySelector("form.custom-contact-form__form");
  if (!form) return;

  // Get all service checkboxes
  const serviceCheckboxes = root.querySelectorAll(".service-checkbox");
  
  // Get the hidden services field
  const hiddenServicesField = root.querySelector(`#ServicesValue-${sectionId}`);
  
  // Get name field
  const nameField = root.querySelector(`#ContactName-${sectionId}`);

  // Update function for services
  function updateSelectedServices() {
    if (!hiddenServicesField) return [];
    
    const selectedServicesArray = Array.from(serviceCheckboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);
    
    const selectedServicesString = selectedServicesArray.join(", ");
    
    // Update the hidden field
    hiddenServicesField.value = selectedServicesString;
    
    return selectedServicesArray;
  }
  
  // Update on checkbox change
  serviceCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", updateSelectedServices);
  });
  
  // Update name field
  function updateNameField() {
    const firstName = root.querySelector(`#first_name-${sectionId}`);
    const lastName = root.querySelector(`#last_name-${sectionId}`);
    
    if (firstName && lastName && nameField) {
      const fullName = `${firstName.value.trim()} ${lastName.value.trim()}`.trim();
      nameField.value = fullName;
    }
  }
  
  // Listen to name input changes
  const firstName = root.querySelector(`#first_name-${sectionId}`);
  const lastName = root.querySelector(`#last_name-${sectionId}`);
  
  if (firstName) firstName.addEventListener("input", updateNameField);
  if (lastName) lastName.addEventListener("input", updateNameField);
  
  // Update on form submit
  form.addEventListener("submit", function() {
    // Force update services before submission
    const selectedServices = updateSelectedServices();
    updateNameField();
    
    // Add services to message as well (as backup)
    const messageField = root.querySelector(`#message-${sectionId}`);
    if (messageField && selectedServices.length > 0) {
      const servicesText = `\n\n---\nRequested Services: ${selectedServices.join(", ")}`;
      if (!messageField.value.includes("Requested Services:")) {
        messageField.value += servicesText;
      }
    }
  });
  
  // Initialize
  updateSelectedServices();
  updateNameField();
}

// Find and initialize ALL contact forms on the page
function initializeAllContactForms() {
  // Look for elements with data-section-id
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(section => {
    const sectionId = section.getAttribute('data-section-id');
    if (sectionId) {
      initContactForm(sectionId);
    }
  });
  
  // Also look for contact form sections by ID pattern
  const contactFormSections = document.querySelectorAll('[id^="ContactFormSection-"]');
  
  contactFormSections.forEach(section => {
    const sectionId = section.id.replace('ContactFormSection-', '');
    if (sectionId) {
      initContactForm(sectionId);
    }
  });
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initializeAllContactForms);

// Also try initializing immediately (in case DOM is already loaded)
if (document.readyState !== 'loading') {
  initializeAllContactForms();
}

// Re-initialize when section reloads in theme editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail && event.detail.sectionId) {
    setTimeout(() => {
      initContactForm(event.detail.sectionId);
    }, 100);
  }
});

  } catch(e) { console.error(e); }
})();
})();
